import React, { useEffect, useMemo } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { trackPageLifecycle } from '../lib/customerEventTracker';

const PrivacyPolicy = () => {
  const { t } = useLanguage();
  useEffect(
    () => trackPageLifecycle({
      funnel_name: 'PRIVACY_PAGE',
      form_name: 'PrivacyPolicy',
      service_code: null,
      open_event_name: 'privacy_page_open',
    }),
    [],
  );

  const sections = useMemo(() => [
    { h: t('privacy.s1_h', '1. Introduction'), p: t('privacy.s1_p', '') },
    { h: t('privacy.s2_h', '2. Information We Collect'), p: t('privacy.s2_p', '') },
    { h: t('privacy.s3_h', '3. How We Use Your Information'), p: t('privacy.s3_p', '') },
    { h: t('privacy.s4_h', '4. Data Security'), p: t('privacy.s4_p', '') },
    { h: t('privacy.s5_h', '5. Information Sharing'), p: t('privacy.s5_p', '') },
    { h: t('privacy.s6_h', '6. Your Rights'), p: t('privacy.s6_p', '') },
    { h: t('privacy.s7_h', '7. Contact Us'), p: t('privacy.s7_p', '') },
  ], [t]);

  return (
    <div className="pt-28 pb-16">
      <section className="py-10 hero-gradient">
        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#0f2540] mb-3">
            {t('privacy.hero_title', 'Privacy')} <span className="text-[#14A098]">{t('privacy.hero_accent', 'Policy')}</span>
          </h1>
          <p className="text-gray-600">{t('privacy.updated', 'Last updated: July 2025')}</p>
        </div>
      </section>
      <section className="max-w-4xl mx-auto px-4 md:px-8 py-14 space-y-6 text-gray-700 leading-relaxed">
        {sections.map((s) => (
          <div key={s.h}>
            <h2 className="text-xl font-bold text-[#0f2540] mb-2">{s.h}</h2>
            <p>{s.p}</p>
          </div>
        ))}
      </section>
    </div>
  );
};

export default PrivacyPolicy;
